const isFrontpage = (value, nodeValue) => {
	return (value === '/frontpage' && nodeValue === '/');
};

const findByValue = (value, key = '', children = '', stack = []) => {
	while(stack.length > 0) {
		const node = stack.pop();
		if(value === node[key] || isFrontpage(value, node[key])) {
			return node;
		}

		if(node[children] && node[children].length > 0) {
			for(let i = 0; i < node[children].length; ++i) {
				stack.push(node[children][i]);
			}
		}
	}

	return null;
};

const getIdByUrl = (url, nav) => {
	const clonedNav = JSON.parse(JSON.stringify(nav));
	const node = findByValue(url, 'Url', 'Children', clonedNav);
	return (node !== null ? node.Id : 0);
};

export {
	getIdByUrl
};
